// Fonction de validation des données
export const validateData = (salaryDetails) => {
  if (!salaryDetails || !salaryDetails.periode || !salaryDetails.periode.debut || !salaryDetails.periode.fin) {
    console.error("Les informations de période sont manquantes ou incomplètes.");
    return false;
  }
  return true;
};

// Ajout de l'en-tête du PDF
export const addHeader = (doc, employeeInfo, salaryDetails, employerInfo) => {
  doc.setFontSize(12);
  doc.text(`MATRICULE ${employeeInfo.matricule || ''}`, 20, 15);
  doc.text(`REF. PERIODE D'EMPLOI : ${employeeInfo.referencePeriode || ''}`, 20, 22);
  doc.text(`DU: ${salaryDetails.periode.debut} AU: ${salaryDetails.periode.fin}`, 20, 29);
  doc.text(`DATE DE PAIEMENT : ${salaryDetails.datePaiement || ''}`, 20, 36);
  doc.text(`NO DE SECURITE SOCIALE: ${employeeInfo.numeroSecu || ''}`, 20, 43);
  doc.setFontSize(10);
  doc.text(`Nº SIRET: ${employerInfo.siret || ''}`, 20, 50);
  doc.text(`Nº APE: ${employerInfo.ape || ''}`, 20, 57);
  doc.text(`CONVENTION COLLECTIVE: ${employerInfo.conventionCollective || ''}`, 20, 64);
  doc.text(`${employerInfo.adresse || ''}`, 20, 71);
};

// Ajout du titre
export const addTitle = (doc) => {
  doc.setFontSize(18);
  doc.text('BULLETIN DE PAIE', 105, 85, { align: 'center' });
};

// Ajout des infos employeur/employé
export const addEmployeeEmployerInfo = (doc, employeeInfo, salaryDetails) => {
  doc.setFontSize(10);
  doc.text(`AFFECTATION : ${employeeInfo.affectation || ''}`, 20, 100);
  doc.text(`MINIMUM CONV. : ${salaryDetails.minimumConventionnel || ''} €`, 80, 100);
  doc.text(`FORFAIT JOURS : ${salaryDetails.forfaitJours || ''}`, 140, 100);
  doc.text(`EMPLOI : ${employeeInfo.poste || ''}`, 20, 108);
  doc.text(`SALAIRE MENSUEL: ${salaryDetails.salaireMensuel || ''} €`, 80, 108);
  doc.text(`TAUX ACTIVITE : ${employeeInfo.tauxActivite || ''}`, 140, 108);
  doc.text(`DATE ENTREE : ${employeeInfo.dateEntree || ''}`, 20, 116);
  doc.text(`NATURE CONTRAT : ${employeeInfo.natureContrat || ''}`, 80, 116);
};

// Préparation des données du tableau
export const prepareTableData = (salaryDetails) => {
  return [
    ['SALAIRE DE FONCTION', '', '', `${salaryDetails.salaireBrut || ''} €`],
    ['SANTE', '', '', ''],
    ['SECURITE SOCIALE - MALADIE MATERNITE', `${salaryDetails.salaireBrut || ''}`, '', `${salaryDetails.cotisations?.maladieMaternite?.employeur || ''} €`],
    ['PREVOYANCE INCAPACITE INVALIDITE DECES', `${salaryDetails.salaireBrut || ''}`, `${salaryDetails.cotisations?.prevoyance?.salarial || ''} %`, `${salaryDetails.cotisations?.prevoyance?.employeur || ''} €`],
    ['COMPLEMENTAIRE SANTE OBLIGATOIRE FORFAIT', '', '', `${salaryDetails.cotisations?.complementaireSante || ''} €`],
    ['RETRAITE', '', '', ''],
    ['SECURITE SOCIALE PLAFONNEE', `${salaryDetails.salaireBrut || ''}`, `${salaryDetails.cotisations?.retraitePlafonnee?.salarial || ''} %`, `${salaryDetails.cotisations?.retraitePlafonnee?.employeur || ''} €`],
    ['SECURITE SOCIALE DEPLAFONNEE', `${salaryDetails.salaireBrut || ''}`, `${salaryDetails.cotisations?.retraiteDeplafonnee?.salarial || ''} %`, `${salaryDetails.cotisations?.retraiteDeplafonnee?.employeur || ''} €`],
    ['RETRAITE COMPLEMENTAIRE TRANCHE 1', `${salaryDetails.salaireBrut || ''}`, `${salaryDetails.cotisations?.retraiteComplementaire?.salarial || ''} %`, `${salaryDetails.cotisations?.retraiteComplementaire?.employeur || ''} €`],
    ['FAMILLE', `${salaryDetails.salaireBrut || ''}`, '', `${salaryDetails.cotisations?.famille || ''} €`],
    ['CHOMAGE', `${salaryDetails.salaireBrut || ''}`, '', `${salaryDetails.cotisations?.chomage || ''} €`],
    ['APEC', `${salaryDetails.salaireBrut || ''}`, `${salaryDetails.cotisations?.apec?.salarial || ''} %`, `${salaryDetails.cotisations?.apec?.employeur || ''} €`],
    ['CSG DEDUCTIBLE DE L\'IMPOT SUR LE REVENU', `${(salaryDetails.salaireBrut || 0) + (salaryDetails.cotisations?.csgCrds || 0)}`, `${salaryDetails.cotisations?.csgDeductible || ''} %`, ''],
    ['CSG/CNDS NON DEDUCTIBLES', `${(salaryDetails.salaireBrut || 0) + (salaryDetails.cotisations?.csgCrds || 0)}`, `${salaryDetails.cotisations?.csgNonDeductible || ''} %`, ''],
    ['TICKETS RESTAURANT', `${salaryDetails.ticketsRestaurant?.base || ''}`, `${salaryDetails.ticketsRestaurant?.taux || ''} %`, `${salaryDetails.ticketsRestaurant?.employeur || ''} €`],
  ];
};

// Ajout du tableau
export const addSalaryTable = (doc, salaryDetails) => {
  const bodyData = prepareTableData(salaryDetails);
  doc.autoTable({
    head: [['DESIGNATION', 'NOMBRE OU BASE', 'PART EMPLOYE', 'EMPLOYEUR']],
    body: bodyData,
    startY: 125,
    styles: { fontSize: 8, cellPadding: 1.5 },
    headStyles: { fillColor: [220, 220, 220] },
  });
};

// Ajout des montants nets et du pied de page
export const addNetAmountsAndFooter = (doc, salaryDetails) => {
  doc.setFontSize(12);
  doc.text(`MONTANT NET SOCIAL : ${salaryDetails.montantNetSocial || ''} €`, 20, doc.lastAutoTable.finalY + 15);
  doc.text(`NET A PAYER AVANT IMPOT SUR LE REVENU : ${salaryDetails.netAvantImpot || ''} €`, 20, doc.lastAutoTable.finalY + 25);
  doc.text(`PRELEVEMENT A LA SOURCE : ${salaryDetails.prelevementSource || ''} €`, 20, doc.lastAutoTable.finalY + 35);
  doc.text(`NET A PAYER : ${salaryDetails.netAPayer || ''} €`, 20, doc.lastAutoTable.finalY + 45);
  doc.setFontSize(8);
  doc.text('Nous vous recommandons de conserver votre bulletin de paie, sans limitation de durée.', 20, doc.internal.pageSize.height - 20);
  doc.text(`Document émis le : ${new Date().toLocaleDateString('fr-FR')}`, 20, doc.internal.pageSize.height - 10);
};
